import { FUNNELS_API } from 'modules/funnels/api/funnels-api'
import { DeadlineSettingsInterface } from 'modules/funnels/funnel/types/deadline-settings-interface'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useFunnelDeadlineSettings(id?: FunnelId) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, DeadlineSettingsInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: deadlineSettings, mutate } = useSWR(() => {
    if (user && id) {
      return `${FUNNELS_API}/${id}/deadline`
    }
    return null
  }, fetcher)

  return { deadlineSettings, mutate }
}
